import React, { useState, createContext } from "react";
import { useNavigate } from 'react-router-dom';

import axios from 'api/axios';


const ContextBlock = createContext();

const BlockProvider = ({ children }) => {
  const navigate = useNavigate();

  //init param
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarType, setSnackBarType] = useState("");

  //info popin
  const [infosPopinMsg, setInfosPopinMsg] = useState('');
  const [infosPopinType, setInfosPopinType] = useState('');
  const [infosPopinTitle, setInfosPopinTitle] = useState('');
  const [openInfosPopin, setOpenInfosPopin] = useState(false);
  const [infosPopinMsgIsHTML, setInfosPopinMsgIsHTML] = useState(false);
  
  //state
  const TRAINING_THEMATIC_LIST_URL = 'training/thematic/list';
  const [trainingThematicRows, setTrainingThematicRows] = useState([]);


  const loadThematicList = async () => {
    try {
      //config call API
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      }
      const response = await axios.get(TRAINING_THEMATIC_LIST_URL, config);
      const rowsFromApi = response.data?.data;
      rowsFromApi.sort((a, b) => (a.name > b.name) ? 1 : -1);
      //init rows
      setTrainingThematicRows(rowsFromApi);
    } catch (err) {
      console.log(err);
      if (err.response?.status === 401) {
        navigate('/deconnexion');
      }
      else {
        setSnackBarMessage('Erreur technique! Veuillez réessayer ou contacter notre support.');
        setSnackBarType('error');
        setOpenSnackBar(true);
      }
    }
  }

  function triggerInfosPopin(title, msg, type = null, isHTML = false) {
    //open error poppin
    setOpenInfosPopin(true);
    setInfosPopinMsg(msg);
    setInfosPopinMsgIsHTML(isHTML);

    if (typeof type == "string")
      setInfosPopinType(type);
    else
      setInfosPopinType('');
    if (typeof title == "string")
      setInfosPopinTitle(title);
    else
      setInfosPopinTitle('');
  }


  return (
    <ContextBlock.Provider
      value=
      {{
        //snackbar
        openSnackBar, setOpenSnackBar,
        snackBarType, setSnackBarType,
        snackBarMessage, setSnackBarMessage,

        //popin
        triggerInfosPopin,
        infosPopinMsg, setInfosPopinMsg,
        openInfosPopin, setOpenInfosPopin,
        infosPopinType, setInfosPopinType,
        infosPopinTitle, setInfosPopinTitle,
        infosPopinMsgIsHTML, setInfosPopinMsgIsHTML,

        //thematic
        TRAINING_THEMATIC_LIST_URL, loadThematicList,
        trainingThematicRows, setTrainingThematicRows
      }}
    >
      {children}
    </ContextBlock.Provider>
  );
};

export { BlockProvider, ContextBlock };
